<template>
  <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-dark" id="sidenav-main">
    <div class="container-fluid">

      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar">
        <span class="navbar-toggler-icon"></span>
      </navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img :src="logo" alt="..." class="navbar-brand-img">
      </router-link>

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <base-dropdown class="nav-item" position="right">
            <a class="nav-link" href="#" role="button" slot="title">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" :src="this.user.image">
                </span>
              </div>
            </a>

            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Willkommen!</h6>
            </div>
            <router-link class="dropdown-item" to="/profile">
              <i class="ni ni-single-02"></i>
              <span>Profil</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#!">
              <i class="ni ni-user-run"></i>
              <span @click="logoutUser">Abmelden</span>
            </a>
          </base-dropdown>
        </ul>
      </slot>
      <slot></slot>
      <div class="navbar-collapse collapse show" id="sidenav-collapse-main" v-show="$sidebar.showSidebar">

        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logo_black">
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"></slot>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import NavbarToggleButton from '@/components/NavbarToggleButton'
  import { mapState } from "vuex";
  import * as firebase from "firebase";
  import store from "../../store";

  export default {
    name: 'sidebar',
    computed: {
      ...mapState({
        user: state => state.user,
      })
    },
    components: {
      NavbarToggleButton
    },
    props: {
      logo: {
        type: String,
        default: 'img/brand/NLS_LOGO_white.png',
        description: 'NEXT LEVEL STUDIOS logo'
      },
      logo_black: {
        type: String,
        default: 'img/brand/NLS_LOGO_black.png',
        description: 'NEXT LEVEL STUDIOS logo'
      },
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    methods: {
      logoutUser() {
        firebase.auth().signOut().then(() => {
          store.commit('removeUser');
          this.$router.replace({ name: "login" });
        });
      },
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      }
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>
<style scoped>
  .navbar-vertical {
    background-image: linear-gradient(265deg, #7c2ca2, rgba(34, 154, 235, .95));
  }
</style>
